import { MoveAwardRequest } from '../../models/move-award-request';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const moveAward: (
  fetchContext: FetchContext,
  awardId: number,
  moveAwardRequest: MoveAwardRequest,
  accessToken?: string,
) => Promise<void> = async (fetchContext, awardId, moveAwardRequest, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/awards/${awardId}/move`,
  {
    method: 'PUT',
    body: JSON.stringify(moveAwardRequest),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'move award'));
